/* ============================================================================
   Product Shade Models — "What Shade Am I?"

   Faithful port of the old theme's theShades module:
     - Usage + Skin Tone filters (AND-intersected against each slide's tags)
     - Swatches/Models toggle swaps the <img src> per slide
     - Skin-tone filter also selects a different model-image set (light/medium/dark)
     - Default-active filter = first button in each group
     - Filter value = the button's textContent (lowercased)
   ========================================================================== */

(function () {
  'use strict';

  var swiperInstance = null;

  function init(root) {
    var wrapper = root.querySelector('[data-psm-wrapper]');
    // Nav arrows live in the outer wrapper (`.psm-slides-outer`) so swiper's
    // overflow:hidden doesn't clip them.
    var navHost = root.parentElement || root;
    if (!wrapper) return;

    // --- Read data attributes ---
    var productImages = splitCsv(root.getAttribute('data-product-images'));
    var modelImages = splitCsv(root.getAttribute('data-model-images'));
    var modelsLightImages = splitCsv(root.getAttribute('data-models-light-images'));
    var modelsMediumImages = splitCsv(root.getAttribute('data-models-medium-images'));
    var modelsDarkImages = splitCsv(root.getAttribute('data-models-dark-images'));
    var productTitles = splitPipe(root.getAttribute('data-product-titles'));
    var productDescriptions = splitPipe(root.getAttribute('data-product-descriptions'));
    // Tag entries: one per slide; each entry is a comma-separated list of tags.
    var allFilters = (root.getAttribute('data-image-tags') || '')
      .split('|')
      .filter(function (s) { return s.trim() !== ''; })
      .map(function (entry) {
        return entry.split(',').map(function (t) { return t.trim().toLowerCase(); });
      });

    var section = root.closest('.psm-section') || root.parentElement;
    var usageFilters = section.querySelectorAll('[data-psm-usage] [data-psm-option]');
    var skinToneFilters = section.querySelectorAll('[data-psm-tone] [data-psm-option]');
    var viewToggle = section.querySelector('[data-psm-view-toggle]');
    var emptyEl = section.querySelector('[data-psm-empty]');
    var loadingEl = section.querySelector('[data-psm-loading]');

    var currentUsageFilter = 'all';
    var currentSkinToneFilter = 'all';
    // Models view is active by default (checkbox is checked in the Liquid).
    var isModel = !viewToggle || !!viewToggle.checked;

    // Snapshot original slide nodes so we can rebuild the DOM as filters change.
    var originalSlides = Array.prototype.slice.call(wrapper.querySelectorAll('.the-shades-slide'));
    originalSlides.forEach(function (slide, i) { slide.dataset.index = i; });

    function getCurrentModelImages() {
      if (currentSkinToneFilter === 'light' && modelsLightImages.length) return modelsLightImages;
      if (currentSkinToneFilter === 'medium' && modelsMediumImages.length) return modelsMediumImages;
      if (currentSkinToneFilter === 'dark' && modelsDarkImages.length) return modelsDarkImages;
      return modelImages;
    }

    function setSlideImagesAndText(container) {
      var pool = isModel ? getCurrentModelImages() : productImages;
      container.querySelectorAll('.the-shades-slide').forEach(function (slide) {
        var idx = Number(slide.dataset.index);
        var img = slide.querySelector('img');
        if (img) {
          var src = pool[idx] || modelImages[idx] || productImages[idx] || '';
          if (src) img.src = src;
          img.removeAttribute('loading');
        }
        var badge = slide.querySelector('.psm-slide__badge, p.badge');
        if (badge && productTitles[idx] != null) badge.textContent = productTitles[idx];
        var title = slide.querySelector('.psm-slide__title, h3.card-title, h2.card-title');
        if (title && productDescriptions[idx] != null) title.textContent = productDescriptions[idx];
      });
    }

    function rebuildCarousel(filteredIndices) {
      destroySwiper();

      wrapper.classList.add('card-list-hidden');
      if (loadingEl) loadingEl.style.display = 'block';

      wrapper.innerHTML = '';

      if (filteredIndices.length === 0) {
        wrapper.classList.add('no-results-state');
        var noResults = document.createElement('div');
        noResults.className = 'psm-no-results';
        noResults.textContent = 'No shades match your selection';
        wrapper.appendChild(noResults);
        if (emptyEl) emptyEl.style.display = 'block';
      } else {
        wrapper.classList.remove('no-results-state');
        if (emptyEl) emptyEl.style.display = 'none';
        filteredIndices.forEach(function (i) {
          var slide = originalSlides[i];
          if (slide) wrapper.appendChild(slide.cloneNode(true));
        });
      }

      setSlideImagesAndText(wrapper);

      setTimeout(function () {
        wrapper.classList.remove('card-list-hidden');
        if (loadingEl) loadingEl.style.display = 'none';
      }, 250);

      initSwiper();
    }

    function applyFilters() {
      var out = [];
      for (var i = 0; i < allFilters.length; i++) {
        var tags = allFilters[i];
        var usageOk = currentUsageFilter === 'all' || tags.indexOf(currentUsageFilter) !== -1;
        var toneOk = currentSkinToneFilter === 'all' || tags.indexOf(currentSkinToneFilter) !== -1;
        if (usageOk && toneOk) out.push(i);
      }
      rebuildCarousel(out);
    }

    // --- Filter button bindings ---
    function bindFilterGroup(btns, getSelected, setSelected) {
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          setSelected((btn.textContent || '').trim().toLowerCase());
          applyFilters();
        });
      });
    }
    bindFilterGroup(usageFilters,
      function () { return currentUsageFilter; },
      function (v) { currentUsageFilter = v; });
    bindFilterGroup(skinToneFilters,
      function () { return currentSkinToneFilter; },
      function (v) { currentSkinToneFilter = v; });

    // --- Nav arrows ---
    // Bind once on the persistent button elements (they live outside the swiper
    // container and survive every rebuild). They drive whatever the current
    // `swiperInstance` is, so navigation keeps working after filters re-init the
    // carousel — unlike Swiper's built-in navigation, which loses its bindings
    // across destroy/re-init.
    var navPrev = navHost.querySelector('[data-psm-prev]');
    var navNext = navHost.querySelector('[data-psm-next]');
    if (navPrev) {
      navPrev.addEventListener('click', function () {
        if (swiperInstance) swiperInstance.slidePrev();
      });
    }
    if (navNext) {
      navNext.addEventListener('click', function () {
        if (swiperInstance) swiperInstance.slideNext();
      });
    }

    // --- View toggle ---
    if (viewToggle) {
      viewToggle.addEventListener('change', function () {
        wrapper.classList.add('card-list-hidden');
        isModel = !!viewToggle.checked;
        setSlideImagesAndText(wrapper);
        setTimeout(function () { wrapper.classList.remove('card-list-hidden'); }, 200);
      });
    }

    // --- Swiper ---
    function initSwiper() {
      if (typeof window.Swiper !== 'function') {
        setTimeout(initSwiper, 80);
        return;
      }
      var slideCount = wrapper.querySelectorAll('.the-shades-slide').length;
      var slidesPerView = 1.3;
      if (window.innerWidth >= 1024) slidesPerView = 4;
      else if (window.innerWidth >= 700) slidesPerView = 3;

      var opts = {
        loop: slideCount > slidesPerView,
        spaceBetween: 18,
        allowTouchMove: slideCount > slidesPerView,
        breakpoints: {
          0: { slidesPerView: 1.3 },
          700: { slidesPerView: 3 },
          1024: { slidesPerView: 4, spaceBetween: 18 }
        },
        on: {
          init: updateNav,
          resize: updateNav,
          update: updateNav
        }
      };

      swiperInstance = new window.Swiper(root, opts);
    }

    function destroySwiper() {
      if (swiperInstance && typeof swiperInstance.destroy === 'function') {
        swiperInstance.destroy(true, true);
      }
      swiperInstance = null;
    }

    function updateNav() {
      var realSlides = wrapper.querySelectorAll('.the-shades-slide').length;
      var slidesPerView = 1.3;
      if (window.innerWidth >= 1024) slidesPerView = 4;
      else if (window.innerWidth >= 700) slidesPerView = 3;

      var next = navHost.querySelector('[data-psm-next]');
      var prev = navHost.querySelector('[data-psm-prev]');
      if (!next || !prev) return;

      if (realSlides <= slidesPerView) {
        next.style.display = 'none';
        prev.style.display = 'none';
        wrapper.style.justifyContent = window.innerWidth > 700 ? 'center' : 'flex-start';
      } else {
        next.style.display = '';
        prev.style.display = '';
        wrapper.style.justifyContent = 'flex-start';
      }
    }

    // Paint initial slides with correct images, then init Swiper.
    setSlideImagesAndText(wrapper);
    initSwiper();
  }

  // ── helpers ──
  function splitCsv(s) {
    if (!s) return [];
    return s.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function splitPipe(s) {
    if (!s) return [];
    return s.split('|').map(function (x) { return x.trim(); });
  }

  function initAll() {
    document.querySelectorAll('[data-psm-slides]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
